var $656f1a37422df52a$exports = {};
$656f1a37422df52a$exports = {
    "Clear search": `T\xf8m s\xf8k`
};


export {$656f1a37422df52a$exports as default};
//# sourceMappingURL=nb-NO.mjs.map
